/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_Secret_KeyInputs */

const en_admin_settings_fields_r2_secret_key = /** @type {(inputs: Admin_Settings_Fields_R2_Secret_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare Secret Key`)
};

const zh_admin_settings_fields_r2_secret_key = /** @type {(inputs: Admin_Settings_Fields_R2_Secret_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloudflare 私有密钥`)
};

/**
* | output |
* | --- |
* | "Cloudflare Secret Key" |
*
* @param {Admin_Settings_Fields_R2_Secret_KeyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_secret_key = /** @type {((inputs?: Admin_Settings_Fields_R2_Secret_KeyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_Secret_KeyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_r2_secret_key(inputs)
	return zh_admin_settings_fields_r2_secret_key(inputs)
});
export { admin_settings_fields_r2_secret_key as "admin.settings.fields.r2_secret_key" }